import React from 'react'
import { useStaticQuery, graphql, Link } from "gatsby"

import breadCrumbsStyles from "./BreadCrumbs.module.css"

export default function BreadCrumbs({ postLink }) {

    const queryData = useStaticQuery(graphql`
        query {
            allMdx {
                edges {
                  node {
                    frontmatter {
                      dir
                      post_title
                    }
                    fields {
                      slug
                    }
                  }
                }
              }
        }
    `)        

    // if URL is unique in the list of slugs, this is a post, otherwise it's a category title
    const isUrlPost = (url) => {
        let URLs = queryData.allMdx.edges.map( ({node}) => node.fields.slug);
        let counter = 0
        URLs.forEach(element => {
            if(element.startsWith(url)){
                counter++
            }
        })
        return counter === 1
    }

    let navLinks = postLink.slice(0, -1).split('/').map(link => `${link}/`)

    const dirName = (index) => {
        let slug = ''
        for (let i = 0; i <= index; i++) {
            slug += navLinks[i]
        }        
        let { node } = queryData.allMdx.edges.filter( ({node}) => node.fields.slug === slug)[0];
        return {
            name: node.frontmatter.dir,
            url: node.fields.slug
        }
    }    

    const breadCrumbLinks = navLinks.map( (link, index) => {
        const {name, url} = dirName(index)
        return (
            <div key={index}>                                                
                {
                    index < navLinks.length - 1 
                    ?
                    <>
                        <Link to={url}>{name}</Link>
                        <span>&gt;</span>
                    </>
                    :
                    <>
                        {name}
                    </>                    
                }
            </div>
        )
    })

    return(
        <>            
            {
                isUrlPost(postLink) && 
                    <div className={breadCrumbsStyles.container}>
                        {breadCrumbLinks}
                    </div>
            }
        </>
    )
}